import { withRef } from "@udecode/cn";
import { getBlocks } from "@udecode/plate-common";
import { useEditorRef, useEditorSelector } from "@udecode/plate/react";

import { ToolbarButton } from "@/components/plate-ui/toolbar";

const ToggleBlockToolbarButton = withRef<typeof ToolbarButton, { blockType: string }>(
    ({ blockType, ...props }, ref) => {
        const editor = useEditorRef();
        const pressed = useEditorSelector(editor => getBlocks(editor), []).some(
            ([b]) => b.type === blockType
        );

        return (
            <ToolbarButton
                ref={ref}
                pressed={pressed}
                onClick={e => {
                    e.preventDefault();
                    editor.tf.toggle.block({ type: blockType });
                }}
                {...props}
            />
        );
    }
);
export default ToggleBlockToolbarButton;
